var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-6 g-3 g-lg- mb-5"},_vm._l((_vm.visitedProducts),function(product){return _c('div',{staticClass:"col"},[_c('product',{attrs:{"product":product}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }